import { render, staticRenderFns } from "./LabelNormalIcon.vue?vue&type=template&id=5f2d6e3e&scoped=true&"
import script from "./LabelNormalIcon.vue?vue&type=script&lang=js&"
export * from "./LabelNormalIcon.vue?vue&type=script&lang=js&"
import style0 from "./LabelNormalIcon.vue?vue&type=style&index=0&id=5f2d6e3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d6e3e",
  null
  
)

export default component.exports